module.exports = __webpack_public_path__ + "img/multiplication-and-division-math-magic-tip3.7d612e11.png";